import { createContext } from "react";

const CaseContext = createContext<any | undefined>(undefined);

export default CaseContext;
